<p-card header="">
<div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
    <div class="flex align-items-center">
        <div>
            <p-button label="New" (click)="createRole()" class="p-button-outlined ml-2 " icon="pi pi-plus" size="small"
                pTooltip="Create Roles"></p-button>
        </div>

        @if(RoleId){
        <div>
            <p-button label="Edit" (click)="editRoles()" class="p-button-outlined ml-2 " icon="pi pi-user-edit"
                severity="secondary" size="small"></p-button>
        </div>
        <div>
            <p-button label="Delete" (click)="deleteRoles()" class="p-button-outlined ml-2" icon="pi pi-trash"
                severity="danger" size="small"></p-button>
        </div>
        }

        <div class="flex align-items-center ml-3">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                    class=" p-inputtext-sm" (keyup.enter)="searchRole()"
                    style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
            </span>
            <p-button icon="pi pi-search" (onClick)="searchRole()" [ngStyle]="{ height: '35px' }" [raised]="true"
                class="ml-2" [size]="'small'" severity="info"></p-button>
        </div>
    </div>

    <h2 class="page-title-center">Roles List</h2>

    <div class="flex">
        <div class="flex align-items-center">
            <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                severity="info"></p-button>
        </div>
    </div>
</div>


      <p-table #dt1 [value]="roleList" [scrollable]="true" scrollHeight="613px"
      styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
      [paginator]="true" [rows]="10" [selectionPageOnly]="true" (onPage)="loadRoles($event)"
      [globalFilterFields]="['roleName']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10 ,15, 20]">
      <ng-template pTemplate="header">
             <tr>
                 <th>
                  <p-tableCheckbox></p-tableCheckbox>
                 </th>
                 <th pSortableColumn="roleName">Role Name <p-sortIcon field="roleName"></p-sortIcon></th>
                 <th>Description </th>
                 <th pSortableColumn="AccessRights">Access Right <p-sortIcon field="AccessRights"></p-sortIcon></th>
                 <th>ReportRights</th>
                 <th>Widgets</th>
                 <th>Settings</th>
                 <th pSortableColumn="isActive">Active<p-sortIcon field="isActive"></p-sortIcon></th>
             </tr>
         </ng-template>
         <ng-template pTemplate="body" let-user>
             <tr>
                 <td>
                    <p-tableCheckbox [value]="user"></p-tableCheckbox>
                 </td>
                 <td>{{user.roleName}}</td>
                 <td>{{user.roleDescription}}</td>
                 <!-- <td>
                    @if(user.AccessRights){
                        <span class="pi pi-check-circle" style="color: green;"></span>
                    }@else{
                        <span class="pi pi-times-circle" style="color: red;"></span>
                    }
                </td> -->
                 <td><span class="pi pi-check-circle" style="color: green;"></span></td>
                 <td><span class="pi pi-check-circle" style="color: green;"></span></td>
                 <td><span class="pi pi-check-circle" style="color: green;"></span></td>
                 <!-- <td><span class="pi pi-check-circle" style="color: green;"></span></td> -->
                <td>
                    @if(user.roleName==='Accountant'){
                        <span class="pi pi-times-circle" style="color: red;"></span>
                    }@else{
                        <span class="pi pi-check-circle" style="color: green;"></span>
                    }
                </td>
                 <td>
                    @if(user.isActive){
                        <span style="color: rgb(0 35 255);">{{ user.isActive.toString() | uppercase }}</span>
                    }@else {
                        <span style="color: rgb(255, 0, 0);">{{ user.isActive.toString() | uppercase }}</span>
                    }
                </td>
             </tr>
         </ng-template>
         <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No Records found.</td>
            </tr>
        </ng-template>
     </p-table>

</p-card>

<p-toast></p-toast>
